import { FormFieldOption } from './form-field';
import { EntityId } from '@shared/core/types';

export function getAutocompleteUserFieldOption(user: { surname: string; name: string; id: EntityId }): FormFieldOption {
  if (user == null) {
    return null;
  }

  return {
    value: user.id,
    label: `${user.id} ${user.surname ? user.surname : ''} ${user.name ? user.name : ''}`,
  };
}
